export function BlazorFocusElement(element) {
    if (element instanceof HTMLInputElement) {
        setTimeout(() => SelectElement(element), 650)
        console.log(element.id)
    }
}
function SelectElement(element) {
    element.focus()
    element.select()
}